var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass: "chip-number",
      class: _vm.classBkgFormatted,
      style: { width: _vm.widthChip }
    },
    [
      _c("span", { staticClass: "semibold", class: _vm.colorNumber }, [
        _vm._v(_vm._s(_vm.numberFormatted))
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }